module.exports = __webpack_public_path__ + "src/themes/scss/vitalliance.theme.css";